module.exports = __webpack_public_path__ + "static/media/previewBook.5204392b.png";